import { connect } from 'react-redux';
import SEARCH_CONTEXT from '../../../helpers/InventorySearchContext';
import { getIsFetching } from '../../../redux/Inventory/selectors/location';
import { getSearchQueryForContext } from '../../../redux/Inventory/selectors/components/search';
import {
  onChangeQuery,
  clearInventoryLocations
} from '../../../redux/Inventory/actions';
import { fetchInventoryLocations } from '../../../redux/Inventory/sagas/routines';
import InventorySearch from '../../../components/inventory/Search';

function mapStateToProps(state, props) {
  const searchQuery = getSearchQueryForContext(state, SEARCH_CONTEXT.LOCATION);
  return {
    ...props,
    query: searchQuery.q,
    queryOptions: { q: searchQuery.q },
    isFetching: getIsFetching(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onSubmit: queryOptions => {
      dispatch(clearInventoryLocations());
      dispatch(fetchInventoryLocations(queryOptions));
    },
    onChange: query => {
      dispatch(onChangeQuery({ context: SEARCH_CONTEXT.LOCATION, query }));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InventorySearch);
